// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3Kxc5","col":"styles_col__3Ejxm"};